import { render } from "./TermsOfService.vue?vue&type=template&id=c8c4b67a"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/MaintenancePack/TermsOfService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8c4b67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8c4b67a', __exports__)) {
    api.reload('c8c4b67a', __exports__)
  }
  
  module.hot.accept("./TermsOfService.vue?vue&type=template&id=c8c4b67a", () => {
    api.rerender('c8c4b67a', render)
  })

}


export default __exports__